import { render, staticRenderFns } from "./StockSnapshotOverview.vue?vue&type=template&id=63a00d42&scoped=true&"
import script from "./StockSnapshotOverview.vue?vue&type=script&lang=js&"
export * from "./StockSnapshotOverview.vue?vue&type=script&lang=js&"
import style0 from "./StockSnapshotOverview.vue?vue&type=style&index=0&id=63a00d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a00d42",
  null
  
)

export default component.exports